import React from "react";
import { HelperText, Subtitle } from "@worthy-npm/clarity";
import LargeCTAcard from "./largeCTAcard";
import CalendlyHelper from "lib/calendly";
import { appUrl, getItemLink } from "helpers/ApplicationHelper";
import GA from "lib/ga";

const ServicesSection = ({ data, pageName, horizScroll, lastItem }) => {
  /**** This component uses Calendly but relies on it loading in the Header ****/

  const largeCardsData = data || [
    {
      type: "consultation",
      title: "Call with a jewelry selling expert",
      bullets: [
        "Build price expectations for your jewelry",
        "Get market insights and selling tips",
        "Discuss online and offline selling options",
        '<span class="text-deleted">$50</span> <b class="bold">Free!</b>',
      ],
      ctaText: "Get Expert Opinion",
      CTAcallBack: (stopAnimation) => {
        GA.expertsConsultExpert();
        CalendlyHelper.showPopupWidget(`from sevices in ${pageName} page`);
        stopAnimation();
      },
    },
    {
      type: "service",
      title: "Managed selling service",
      bullets: [
        "Professional cleaning, studio photos & grading",
        "Personal account executive",
        "Access to large buyer pool",
        "Constant updates",
        'Walk away with <b class="bold">80% of sale price</b>',
      ],
      ctaText: lastItem ? "Continue Selling" : "Start Selling",
      CTAcallBack: (stopAnimation) => {
        GA.expertsStartSelling();
        const link = lastItem
          ? getItemLink(lastItem)
          : "/submit/multiple_jewelry";
        window.location = appUrl(link);
        stopAnimation();
      },
    },
  ];

  if (horizScroll) {
    return (
      <div className="experts-services-section horizontal margin-0-auto">
        <div className="text-container">
          <HelperText text={"Get expert assistance"} />
          <Subtitle text={"Professional Resources & Services"} bold={true} />
        </div>
        <div className="slider d-flex">
          <div className="large-cards-container d-flex w-100">
            {largeCardsData.map((card, i) => {
              return (
                <LargeCTAcard
                  key={i}
                  type={card.type}
                  title={card.title}
                  bullets={card.bullets}
                  ctaText={card.ctaText}
                  CTAcallBack={card.CTAcallBack}
                  isSecondaryCTA={card.secondaryCTA}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="experts-services-section margin-0-auto">
      <HelperText text={"Get expert assistance"} />
      <Subtitle text={"Professional Resources & Services"} bold={true} />
      <div className="large-cards-container">
        {largeCardsData.map((card, i) => {
          return (
            <LargeCTAcard
              key={i}
              type={card.type}
              title={card.title}
              bullets={card.bullets}
              ctaText={card.ctaText}
              CTAcallBack={card.CTAcallBack}
              isSecondaryCTA={card.secondaryCTA}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ServicesSection;
